// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kGOcEMWMtYKtkDyFy4ND{background-color:var(--background-primary-inverted-primary);z-index:var(--zIndex-BASE_2);vertical-align:inherit;padding:0;display:table-cell;position:-webkit-sticky;position:sticky;top:0;left:0}.kGOcEMWMtYKtkDyFy4ND.Af6BxNzwsDMMhItyKnAy:before{content:"";background:var(--black-20);width:1px;height:40px;position:absolute;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pinnedRow": `kGOcEMWMtYKtkDyFy4ND`,
	"borderRight": `Af6BxNzwsDMMhItyKnAy`
};
export default ___CSS_LOADER_EXPORT___;
